<script setup lang="ts">
import type { Project } from "./ProjectBlock.vue";
import type { ProjectList } from "~/layers/projects/types/project-block";

interface Props {
  /** Слаги страниц проектов (project-page.slug) — в том порядке, в каком их выбрали в админке. */
  slugs: string[];
  title?: string;
}

const props = withDefaults(defineProps<Props>(), {
  title: "Доступно в проектах",
});

const { section } = useThemeColor("light");

const { find } = useStrapi();
const { data: projectsData } = await useAsyncData("realty-projects", () => find<ProjectList[]>("realty/list/projects"));

// Акция ссылается на страницу проекта, карточка живёт в реалти-каталоге: связь по слагу страницы
const getProjects = computed<Project[]>(() => {
  if (!projectsData.value?.length || !props.slugs?.length) return [];

  const bySlug = new Map<string, Project>();
  for (const list of projectsData.value) {
    for (const item of list.items) {
      if (item.href && !item.commerce_only && !bySlug.has(item.href)) {
        bySlug.set(item.href, item);
      }
    }
  }

  return props.slugs.map((slug) => bySlug.get(slug)).filter((project): project is Project => !!project);
});

const SLIDES_PER_VIEW_DESKTOP = 2;
</script>

<template>
  <section v-if="getProjects.length" ref="section" class="py-20 md:py-[120px]">
    <Container>
      <Carousel :opts="{ align: 'start' }">
        <div class="flex items-center justify-between gap-4 mb-10">
          <Heading class="leading-[100%] mb-0" as="h2" variant="3">{{ title }}</Heading>
          <div v-if="getProjects.length > SLIDES_PER_VIEW_DESKTOP" class="max-md:hidden flex w-fit gap-2.5">
            <CarouselPrevious variant="outline_alt" class="transform-none static" />
            <CarouselNext variant="outline_alt" class="transform-none static" />
          </div>
        </div>
        <CarouselContent viewport-class="-mx-4 px-4 sm:-mx-8 sm:px-8 md:mx-0 md:px-0" class="-ml-5">
          <CarouselItem v-for="item in getProjects" :key="item.title" class="pl-5 basis-[90%] md:basis-1/2">
            <ProjectItem :project="item" title-as="div" compact />
          </CarouselItem>
        </CarouselContent>
      </Carousel>
    </Container>
  </section>
</template>

<style scoped></style>
